export const CATEGORIES = [
  'social_commerce',
  'alerts',
  'memberships',
  'social_feeds',
  'email_marketing',
  'other',
] as const

export const CATEGORY_LABELS: Record<Category, string> = {
  social_commerce: 'Social commerce',
  alerts: 'Alerts',
  memberships: 'Memberships',
  social_feeds: 'Social feeds',
  email_marketing: 'Email marketing',
  other: 'Other',
}

export type Category = (typeof CATEGORIES)[number]

export type AppStatus =
  | 'COMING_SOON'
  | 'CONFIGURED'
  | 'CONNECTED'
  | 'CONNECTING_IN_PROGRESS'
  | 'DISCONNECTING_IN_PROGRESS'
  | 'EXTERNAL'
  | 'IN_PROGRESS'
  | 'NOT_CONFIGURED'
  | 'NOT_CONNECTED'
  | 'SYNCING'
  | 'BROKEN'
  | boolean
  | undefined

export type TextAppStatus = Exclude<AppStatus, boolean | undefined>

export type App = {
  categories: Category[]
  status: AppStatus
  connected: boolean
  title: string
  description: string
  docs?: string
  thumbnail: string
  to: string
  id: string
  hidden?: boolean
  type?: 'beta' | 'thirdParty' | 'draft' | 'community'
}
